module.exports = __webpack_public_path__ + "img/ot-qiusdc_usdc.ee6d51f5.png";